<div class="page-container">
  <div class="pages-page">
    <mat-toolbar class="cdc-header">
      <span>{{ 'Pages' | translate }}</span>

      <div class="d-flex flex-row align-items-center gap-2">
        <div class="cdc-form-field m-0 actif">
          <input matInput type="text" (keyup)="applyFilter($event)" placeholder="{{ 'Search' | translate }}">
        </div>
        <button mat-stroked-button class="cdc-button" (click)="addNewPage()">{{ 'New Page' | translate }}</button>
      </div>
    </mat-toolbar>
    <div class="div-table ">
      <div class="mat-elevation-z8 col-11 col-lg-11 col-md-11 m-3">
        <table mat-table [dataSource]="dataSource" matSort class="custom-table">

          <!-- Title Column -->
          <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef> {{ 'Title' | translate }}</th>
            <td #pageTitle mat-cell *matCellDef="let page" class="ellipsis-cell" tooltipTruncate [matTooltip]="(page.parentPage !== null && page.parentPage !== undefined ? page.parentPage.title + ' > ' : '') + page.title!"> {{ page.parentPage !== null && page.parentPage !== undefined ? page.parentPage.title + " > ": "" }}{{ page.title }} </td>
          </ng-container>

          <!-- Type Column -->
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef> {{ 'Type' | translate }} </th>
            <td #pageType mat-cell *matCellDef="let page"> {{ PageType[page.type] | translate }}</td>
          </ng-container>
          <!-- Offers Column -->
          <ng-container matColumnDef="offers">
            <th mat-header-cell *matHeaderCellDef> {{ 'Offers' | translate }}</th>
            <td mat-cell *matCellDef="let page" class="offers-cell">
              <ng-container *ngIf="page.offers !== null">
                <div #offerName *ngFor="let offer of page.offers" class="label label-primary offer-item" tooltipTruncate [matTooltip]="offer.name!">
                  {{ offer.name }}
                </div>
              </ng-container>
            </td>
          </ng-container>
          <!-- Order Column -->
          <ng-container matColumnDef="order">
            <th mat-header-cell *matHeaderCellDef> {{ 'Order' | translate }} </th>
            <td #pageOrder mat-cell *matCellDef="let page"> {{ page.type === PageType.CUSTOMER ? page.order : '' }}</td>
          </ng-container>
          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="actions-header">
            </th>
            <td mat-cell *matCellDef="let page">
              <div matTooltip="{{ (page.offers !== null && page.offers.length > 0 ? 'Cannot Delete': 'Delete') | translate }}">
                <button mat-icon-button (click)="deletePage($event, page)" [disabled]="page.offers !== null && page.offers.length > 0">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let page; columns: displayedColumns" (click)="navigateToPage(page.id)" class="table-row"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="99">{{ 'No items to display' | translate }}</td>
          </tr>
        </table>
        <mat-paginator [length]="totalItems" [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" [showFirstLastButtons]="true"></mat-paginator>
      </div>
    </div>

  </div>
</div>

